import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
    PDFViewer,
} from "@react-pdf/renderer";


const RecieptPdf = () => (
    <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.display}>
                    <View style={{width: "10%"}}>
                <Image
                    src={require("../../../assets/img/state-govt-logo.png")}
                    alt="Logo"
                    style={{
                        width: "100%"
                    }}
                />
                </View>
                <View style={styles.header}>
                    <Text style={{width: "100%", textAlign: "center"}}>Katsina STATE GOVERNMENT</Text>
                    <View style={styles.subHeader}>
                    <Text>Katsina INTEGRATED REVENUE MANAGEMENT AND ASSURANCE SYSTEM (KIRMAS)</Text>
                </View>
                </View>
                <View style={{width: "10%"}}>
                <Image
                    src={require("../../../assets/img/state-govt-logo.png")}
                    alt="Logo"
                    style={{
                        width: "100%"
                    }}
                />
                </View>
                </View>
                <View style={{display: "flex", flexDirection: "row", justifyContent: "space-between",  alignItems: "center"}}>
                <View style={styles.section}>
                    <Text>
                        <Text style={styles.bold}>Invoice Date: </Text>2024/02/01 03:02:00 AM
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Tax ID: </Text>3253
                    </Text>
                    <Text>
                        <Text style={styles.bold}>TIN No: </Text>04625697-00
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Economic Code: </Text>112420201113210
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Name: </Text>Brainstorm IT Solutions Ltd
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Mobile No: </Text>09032818956
                    </Text>
                    <Text>
                        <Text style={styles.bold}>MDA: </Text>Katsina State Internal Revenue Service
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Invoice for: </Text>Paye Org. Private Sector
                    </Text>
                    <Text>
                        <Text style={styles.bold}>Period: </Text>1 December, 2023 – 31 December, 2023
                    </Text>
                </View>
                <View>
                <Image
                    src={require("../../../assets/img/katsina.png")}
                    alt="Logo"
                    style={{
                        width: "70%"
                    }}
                />
                </View>
                </View>
                <View style={styles.header}>
                    <Text>EVIDENCE OF PAYMENT</Text>
                </View>
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={[styles.tableRow, styles.tableColHeader]}>
                        <Text style={[styles.tableCol, styles.tableColSmall]}>S/N</Text>
                        <Text style={styles.tableCol}>DATE</Text>
                        <Text style={styles.tableCol}>SOURCE ACCOUNT</Text>
                        <Text style={styles.tableCol}>TSA ACCOUNT</Text>
                        <Text style={styles.tableCol}>AMOUNT (N)</Text>
                    </View>
                    {/* Table Row */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCol, styles.tableColSmall]}>1</Text>
                        <Text style={styles.tableCol}>Paye Org. Private Sector</Text>
                        <Text style={styles.tableCol}>12345678901234567890</Text>
                        <Text style={styles.tableCol}>12345678901234567890</Text>
                        <Text style={styles.tableCol}>40,000.00</Text>
                    </View>
                    {/* Total Row */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCol, styles.tableColSmall]}></Text>
                        <Text style={styles.tableCol}>Total</Text>
                        <Text style={styles.tableCol}>400,000.00</Text>
                    </View>
                </View>
                <Image
                    style={styles.qrCode}
                    src="https://via.placeholder.com/50"
                />
            </Page>
        </Document>
    </PDFViewer>
);

export default RecieptPdf;


const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        lineHeight: 1.6,
    },
    display: {
        flexDirection: "row",
        width: "100%",
    },
    header: {
        textAlign: "center",
        fontSize: 14,
        marginBottom: 10,
        fontWeight: "bold",
        textTransform: "uppercase",
        width: "100%"
    },
    subHeader: {
        textAlign: "center",
        fontSize: 10,
        marginBottom: 20,
        width: "100%"
    },
    section: {
        marginBottom: 10,
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCol: {
        width: "50%",
        borderStyle: "solid",
        borderColor: "#000",
        borderBottomWidth: 1,
        borderRightWidth: 1,
        padding: 5,
    },
    tableColHeader: {
        backgroundColor: "#f0f0f0",
        fontWeight: "bold",
    },
    tableColSmall: {
        width: "10%",
    },
    qrCode: {
        width: 50,
        height: 50,
        position: "absolute",
        right: 0,
    },
    bold: {
        fontWeight: "bold",
    },
});